<template>
  <div v-bind:class="{ 'bottom-buttons': from === 'bottom' }">
    <div class='variant' v-if="from === 'description'">
      <v-layout row wrap class='application application--example pa-3 grey lighten-3' v-on:click='showVariant()'>
        <v-flex xs9>{{ attributes() }}</v-flex>
        <v-flex>
          <span class='selected text-xs-right'>{{ $t('Select') }}</span>
        </v-flex>
      </v-layout>
    </div>
    <add-to-cart
      v-else
      v-on:click="showVariant()"
      class="product-detail-buy-now-component"
      rp-link="disable"
      v-bind:rp-label="$t('Buy_now')"
      mode="custom">
    </add-to-cart>

    <div v-if='isCardModalActive' class='overlay overlay--active' style='z-index: 201;'>
      <v-dialog v-model='isCardModalActive' max-width='500px' class='modal'>
        <v-card>
          <variant-modal v-on:modalActive='closeModal()' v-bind:variantDefault='variantDefault' v-bind:variantDetail='variantDetail' v-bind:param='param'></variant-modal>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import VariantModal from '../../productVariants/index.vue'

export default {
  name: 'VariantButton',
  components: {
    VariantModal
  },
  props: {
    from: {
      default: function () { return 'description' },
      type: String
    }
  },
  data: () => {
    return {
      isCardModalActive: false,
      variantDefault: [],
      variantDetail: [],
      param: ''
    }
  },
  computed: {
    ...mapGetters([
      'getProductDetail'
    ])
  },
  methods: {
    ...mapActions({
      getProductVariantAPI: 'getProductVariantAPI'
    }),
    showVariant () {
      this.param = 'product_id=' + this.getProductDetail.product.id
      this.getProductDetail.product_attribute.forEach((element) => {
        element.value.forEach((elementVal, indexVal) => {
          if (indexVal === 0) {
            this.param += '&attribute[' + element.name + ']=' + elementVal
          }
        })
      })
      this.getProductVariantAPI(this.param).then(results => {
        this.variantDetail = results
        this.isCardModalActive = true
        this.getDefaultAttributes()
      })
    },
    closeModal () {
      this.isCardModalActive = false
    },
    attributes () {
      var attr = ''
      this.getProductDetail.product_attribute.forEach((element, index) => {
        if (index > 0) {
          attr += ' / '
        }
        attr += element.name
      })
      return attr
    },
    getDefaultAttributes () {
      this.variantDefault = []
      this.getProductDetail.product_attribute.forEach((element) => {
        element.value.forEach((elementVal, indexVal) => {
          if (indexVal === 0) {
            // this.variantDefault.push({name: element.name, value: element.value, default: elementVal})
            this.variantDefault.push({default: elementVal})
          }
        })
      })
      return this.variantDefault
    }
  }
}
</script>

<style type='text/css' lang='scss'>
  .bottom-buttons {
    height: 100%;
  }

  .variant {
      width: 100%;
      font-size: 16px;
      .selected {
        float: right;
        color: blue;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productDetail/productPrice/productVariantButton.vue